export default "__VITE_ASSET__6c662a8d__"